// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"TemplateListTable_tableContainer__3SzUk","loadingSpinner":"TemplateListTable_loadingSpinner__1e5EY"};